import type { ColumnProps } from '#/common/components/DataGrid';

const columns: ColumnProps<Record<string, string>>[] = [
  // Mandatory columns
  {
    dataField: 'third_party_id',
    caption: 'Work Order ID',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'title',
    caption: 'Title',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'asset',
    caption: 'Asset',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'category',
    caption: 'Category',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'description',
    caption: 'Description',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'state',
    caption: 'Status',
    dataType: 'string',
    visible: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },

  // Optional columns
  {
    dataField: 'assigned_to_email',
    caption: 'Assigned To',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'type',
    caption: 'Type',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'priority',
    caption: 'Priority',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
  {
    dataField: 'due_date',
    caption: 'Due Date',
    dataType: 'string',
    visible: false,
    showInColumnChooser: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
  },
];

export default columns;
